import React  from 'react'
import DropDown from '../dropdown';
import {Users} from '../../../api/services/next'

const NextUsersDropDown = ({...rest}) => {
    return <DropDown api={Users.GetUsers} textField="UserName" valueField="Id"  {...rest}/> 
}

export default NextUsersDropDown;
